export default {
	"notice": {
		"createdDt": "消息产生时间",
		"readDt": "消息阅读时间",
		"unread": "未读"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/notice/notice.js